import React from 'react';
import { Link } from 'react-router-dom';
import { InfinityIcon, TruckIcon, LayersIcon, MailIcon, ShieldIcon } from 'lucide-react';
import { UspsBadge } from './UspsBadge';
import { PaymentLogos } from './PaymentLogos';
const promises = [{
  icon: InfinityIcon,
  title: 'Lifetime replacement on multi-packs',
  body: 'Break it. We replace it. Optional on single X1 orders. Terms apply.',
  gold: true
}, {
  icon: LayersIcon,
  title: 'Full lens system',
  body: 'Clear, Amber and Smoke in every Complete System, or add them to your build.'
}, {
  icon: TruckIcon,
  title: 'Free U.S. shipping',
  body: 'Free standard shipping on every order.'
}, {
  icon: ShieldIcon,
  title: 'Built for real work',
  body: 'Made for people who use their hands.'
}];
const columns = [{
  title: 'Shop',
  links: [{
    label: '1 X1 system for $49.95',
    href: '/#offer'
  }, {
    label: 'Buy 2, get 1 free: $99.90',
    href: '/#offer'
  }, {
    label: 'Buy 4, get 2 free: $179.90',
    href: '/#offer'
  }, {
    label: 'Business / crew pack: $699.90',
    href: '/#company'
  }]
}, {
  title: 'Product',
  links: [{
    label: 'The 3-lens system',
    href: '/#lenses'
  }, {
    label: 'Product details',
    href: '/#details'
  }, {
    label: 'Specs & answers',
    href: '/#specs'
  }, {
    label: 'How it compares',
    href: '/#why'
  }]
}, {
  title: 'Support',
  links: [{
    label: 'Lifetime replacement',
    href: '/#guarantee'
  }, {
    label: 'Shipping & returns',
    href: '/#shipping'
  }, {
    label: 'Reviews',
    href: '/#reviews'
  }, {
    label: 'FAQ',
    href: '/#faq'
  }, {
    label: 'Activate your X1',
    href: '/activate'
  }, {
    label: 'Verify your GritVue',
    href: '/verify'
  }, {
    label: 'Crew Rewards',
    href: '/rewards'
  }, {
    label: 'Contact us',
    href: '/legal/contact'
  }]
}];
const legal = [{
  label: 'Privacy policy',
  to: '/legal/privacy'
}, {
  label: 'Terms of service',
  to: '/legal/terms'
}, {
  label: 'Returns & refunds',
  to: '/legal/returns'
}, {
  label: 'Shipping policy',
  to: '/legal/shipping'
}, {
  label: 'Warranty & protection terms',
  to: '/legal/guarantee'
}, {
  label: 'Legal notice & safety',
  to: '/legal/legal-notice'
}, {
  label: 'Contact us',
  to: '/legal/contact'
}];
export function SiteFooter() {
  return <footer id="support" className="scroll-mt-20 bg-ink-950" data-id="element-1126" data-mp="283eti8tvlvhz">
      <div className="border-y border-white/10 bg-ink-900" data-id="element-1127" data-mp="282vdixnsdh6l">
        <ul className="mx-auto grid max-w-[1400px] gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1128" data-mp="234bqsv1dc1d6">
          {promises.map(promise => {
          const Icon = promise.icon;
          return <li key={promise.title} className={`flex items-start gap-3 px-5 py-6 lg:px-6 ${promise.gold ? 'bg-[#1a1408]' : 'bg-ink-900'}`} data-id="element-1129" data-mp="1tfa7ovzj13uz">
                <Icon className={`mt-0.5 h-6 w-6 shrink-0 ${promise.gold ? 'text-[#f2c94c]' : 'text-grit-500'}`} aria-hidden="true" data-id="element-1130" data-mp="1kcsm8jrp4f91" />
                <span data-id="element-1131" data-mp="3r11eo8jv2j6p">
                  <span className={`block font-display text-lg font-bold uppercase leading-tight tracking-wide ${promise.gold ? 'gold-text' : 'text-offwhite'}`} data-id="element-1132" data-mp="3r3xb1sg28zt1">
                    {promise.title}
                  </span>
                  <span className="mt-1 block text-[13px] text-steel-400" data-id="element-1133" data-mp="8tvevqhsrpv8">{promise.body}</span>
                </span>
              </li>;
        })}
        </ul>
      </div>

      <div className="mx-auto grid max-w-[1400px] gap-10 px-4 py-14 sm:px-6 lg:grid-cols-[1.5fr_1fr_1fr_1fr] lg:px-8 lg:py-16" data-id="element-1134" data-mp="3dao2ftzxsibk">
        <div data-id="element-1135" data-mp="3m2q39tdx40md">
          <span className="block font-display text-4xl font-extrabold uppercase leading-none tracking-tight text-offwhite" data-id="element-1136" data-mp="3m39kt8znomzv">
            Grit<span className="text-grit-500" data-id="element-1137" data-mp="2pk2815iuuwk1">Vue</span>
            <sup className="ml-1 align-super text-[11px] text-steel-500" data-id="element-1138" data-mp="2tmfb1m67wgd4">™</sup>
          </span>
          <span className="mt-1.5 block text-[10px] font-semibold uppercase tracking-[0.34em] text-steel-400" data-id="element-1139" data-mp="2ahtqwriucgzd">
            See the job through
          </span>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-steel-400" data-id="element-1140" data-mp="25kacnrm5847f">
            GritVue X1 is illuminated work eyewear with built-in hands-free light and three interchangeable lenses.
            Designed for mechanics, builders, techs, drivers and anyone who works with their hands.
          </p>
          <div className="mt-6 border border-white/12 bg-ink-900 p-5" data-id="element-1141" data-mp="2t6gut6pa70bd">
            <h2 className="font-display text-xl font-bold uppercase tracking-wide text-offwhite" data-id="element-1142" data-mp="2o8700x7gy1qa">
              Support &amp; contact
            </h2>
            <p className="mt-2 text-sm text-steel-400" data-id="element-1143" data-mp="3344yim4v7i5o">
              Questions, order help or a lifetime replacement claim. A real person answers.
            </p>
            <a href="mailto:support@gritvuegear.com" className="mt-4 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-offwhite transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-1144" data-mp="18t013zkdg1ys">
              <MailIcon className="h-4 w-4 text-grit-500" aria-hidden="true" data-id="element-1145" data-mp="3kgbk63rrs9kw" />
              support@gritvuegear.com
            </a>
            <p className="mt-2 text-xs font-semibold uppercase tracking-wide text-steel-500" data-id="element-1146" data-mp="35q4aacftvyvt">
              Monday to Friday · 8am to 6pm CT
            </p>
            <address className="mt-5 border-t border-white/10 pt-4 text-[13px] not-italic leading-relaxed text-steel-400" data-id="element-1147" data-mp="2wqh9nsuxax3t">
              <span className="block text-[10px] font-bold uppercase tracking-[0.22em] text-steel-500" data-id="element-1148" data-mp="30svswe2i7yvm">
                U.S. fulfillment network
              </span>
              GritVue Gear ships from U.S. warehouses in Fort Worth, TX, Tampa, FL and Los Angeles, CA.
            </address>
            <div className="mt-4" data-id="element-1149" data-mp="l0eyk8af8t7c">
              <UspsBadge data-id="element-1150" data-mp="l1hpgg7quvn9" />
            </div>
          </div>
        </div>

        {columns.map(column => <nav key={column.title} aria-label={column.title} data-id="element-1151" data-mp="pxoxcejpah7u">
            <h2 className="font-display text-lg font-bold uppercase tracking-[0.12em] text-offwhite" data-id="element-1152" data-mp="ojni7kqdoua1">
              {column.title}
            </h2>
            <ul className="mt-5 grid gap-3" data-id="element-1153" data-mp="jlvtezl15oa2">
              {column.links.map(link => <li key={link.label} data-id="element-1154" data-mp="emix7o89r4ut">
                  <Link to={link.href} className="text-sm text-steel-400 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-1155" data-mp="9lv3gusno9ww">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>)}
      </div>

      <div className="border-t border-white/10" data-id="element-1156" data-mp="xhpoaeoyyd46">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-6 px-4 py-8 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-1157" data-mp="skqz8ak5wwcu">
          <nav aria-label="Legal" data-id="element-1158" data-mp="1q164tyxh4v83">
            <ul className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-1159" data-mp="1l8v792q7hlip">
              {legal.map(item => <li key={item.label} data-id="element-1160" data-mp="1thisvtp22jpi">
                  <Link to={item.to} className="text-xs font-semibold uppercase tracking-wide text-steel-400 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-1161" data-mp="1tikh6zv312p6">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-1162" data-mp="2cgd7n2oirk5o">
            <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-steel-500" data-id="element-1163" data-mp="2cgn2b3kiefhp">Secure checkout</p>
            <div className="mt-2" data-id="element-1164" data-mp="2gh6vjw1yoyyk">
              <PaymentLogos data-id="element-1165" data-mp="2ggfbnihq8po4" />
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-1166" data-mp="2l9zycedvdx80">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-3 px-4 py-6 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-1167" data-mp="2q7s163g1z3qz">
          <p className="text-xs text-steel-500" data-id="element-1168" data-mp="2v8610y7i37dx">© {new Date().getFullYear()} GritVue. All rights reserved.</p>
          <p className="max-w-xl text-xs leading-relaxed text-steel-500" data-id="element-1169" data-mp="306hah7tvvfvm">
            GritVue X1. Illuminated work glasses with built-in hands-free light and three interchangeable lenses.
          </p>
          <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-steel-400" data-id="element-1170" data-mp="3ghbah7c2yzhy">Light where you look</p>
        </div>
      </div>
    </footer>;
}